import React, { useState } from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import logo from "../assets/lb/LOGO.webp";
import twitter from "../assets/twitter.png";
import discord from "../assets/discord.png";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  // تابع برای تغییر وضعیت منوی همبرگری
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header>
      <nav className="header-container">
        {/* بخش لوگو */}
        <div className="header-left">
          <div className="logodiv">
            <Link to="/">
              <img className="logoimgheader" src={logo} alt="Main Logo" />
            </Link>
          </div>
        </div>

        {/* دکمه همبرگری */}
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>

        {/* بخش لینک‌ها */}
        <div className={`header-center ${menuOpen ? "active" : ""}`}>
          <div className="texts">
            <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            <Link to="/roadmap" onClick={() => setMenuOpen(false)}>Roadmap</Link>
            <Link to="/Art" onClick={() => setMenuOpen(false)}>Art</Link>
            <Link to="/Artstudio" onClick={() => setMenuOpen(false)}>Artstudio</Link>
            <Link to="/Cybersoul" onClick={() => setMenuOpen(false)}>LiaAI</Link>
          </div>
        </div>

        {/* بخش آیکون‌های شبکه‌های اجتماعی */}
        <div className="header-right">
          <div className="twitter">
            <a href=" https://x.com/LiaAI_abs" target="_blank" rel="noopener noreferrer">
              <img src={twitter} alt="twitter" />
            </a>
            <a href="http://discord.gg/xe3tVQfQAc" className="discord" target="_blank" rel="noopener noreferrer">
              <img src={discord} alt="discord" />
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
